import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import "./style.css";
import { useNavigate } from 'react-router';
import { RoutesPaths } from '../../Router/constant';
import { Modal } from 'react-bootstrap';

export default function AccountCloseForm() {
    const {
        handleSubmit,
        formState: { errors },
        control,
        reset
    } = useForm();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    const onSubmit = async (data) => {
        if (data) {
            reset()
            setShowModal(true);
        }
    };
    const onClose = () => {
        reset()
        setShowModal(false);
        navigate(RoutesPaths.SIGNIN)
    }
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-2"></div>
                <div className="col-md-8 Maincontainer">
                    <div className="innercontainerform">
                        <div className="declaration">
                            <div className="card card-plain card-login">
                                <div className="card-header pb-0 text-left bg-transparent">
                                    <div className="Mainheading">
                                        <h3 className="font-weight-bolder text-info text-gradient">
                                            Account Closing Form
                                        </h3>
                                        <div className="msgicon"><i class="fa-solid fa-user-lock"></i></div>
                                    </div>
                                </div>
                                <div className="card-body">

                                    <form
                                        onSubmit={handleSubmit(onSubmit)}
                                        className="form-group">
                                        <div className="formInput">
                                            <Controller
                                                control={control}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        maxLength={50}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter your name"
                                                    />
                                                )}
                                                name="name"
                                                rules={{
                                                    required: {
                                                        value: true,
                                                        message: "Name is required",
                                                    },
                                                }}
                                            />
                                            {errors && errors.name && (
                                                <span className="errorMessage">
                                                    {errors?.name?.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className="formInput">
                                            <Controller
                                                control={control}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        maxLength={50}
                                                        autoComplete="nope"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Email"
                                                    />
                                                )}
                                                name="email"
                                                rules={{
                                                    required: {
                                                        value: true,
                                                        message: "Email is required",
                                                    },
                                                    pattern: {
                                                        value:
                                                            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                                                        message: "Email is invalid",
                                                    },
                                                }}
                                            />
                                            {errors && errors.email && (
                                                <span className="errorMessage">
                                                    {errors?.email?.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className="formInput">
                                            <Controller
                                                control={control}
                                                render={({ field }) => (
                                                    <textarea
                                                        {...field}
                                                        maxLength={500}
                                                        autoComplete="nope"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter note here"
                                                    />
                                                )}
                                                name="note"
                                                rules={{
                                                    required: {
                                                        value: true,
                                                        message: "Note is required",
                                                    },
                                                }}
                                            />
                                            {errors && errors.note && (
                                                <span className="errorMessage">
                                                    {errors?.note?.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className="submitbutton">
                                            <button className="btn btncust" type='submit'>
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                className="modal-custom">
                <Modal.Body>
                    <div className="deleteAccountModal">
                        <h5>Confirm</h5>
                        <p>
                            Your account closure request has been sent successfully. Please
                            wait for a response.
                        </p>

                        <div className="submitbutton">
                            <button onClick={onClose} type="submit" className="btn btncust">
                                Got it
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
